var _style, _path, _path2, _path3, _path4, _circle, _path5, _path6, _defs, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _circle2, _circle3, _circle4, _circle5, _path15, _path16, _path17, _path18, _path19, _path20, _g, _g2, _circle6, _path21, _path22, _path23, _path24, _circle7, _circle8, _path25, _defs2, _path26, _path27, _ellipse, _ellipse2, _circle9, _circle10, _g3, _g4, _path28, _defs3, _path29, _path30, _path31, _path32, _path33, _g5, _path34, _path35, _ellipse3, _ellipse4, _path36, _g6, _path37, _path38;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1189 1080",
    style: {
      enableBackground: "new 0 0 1189 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#7491EE;}\n\t.st2{fill:#A2B6F3;}\n\t.st3{fill:#434356;}\n\t.st4{fill:#DCE5FF;}\n\t.st5{clip-path:url(#SVGID_00000108278495486170344290000014128464015909473427_);}\n\t.st6{fill:#FCFCFC;}\n\t.st7{fill:#181A1F;}\n\t.st8{fill:#CB0302;}\n\t.st9{fill:#1748E2;}\n\t.st10{fill:#FFFE67;}\n\t.st11{opacity:0.9;}\n\t.st12{fill:#D1DAF9;}\n\t.st13{fill:#B2ECDA;}\n\t.st14{opacity:0.74;fill:#5FD8B2;}\n\t.st15{fill:#5FD8B2;}\n\t.st16{clip-path:url(#SVGID_00000075873574798661736910000009881660252648982458_);fill:#B2ECDA;}\n\t.st17{fill:#7FE0C1;}\n\t.st18{fill:#E20100;}\n\t.st19{opacity:0.6;fill:#E20100;}\n\t.st20{opacity:0.73;fill:#E83433;}\n\t.st21{clip-path:url(#SVGID_00000165203626344165214870000002961800343484314807_);fill:#7FE0C1;}\n\t.st22{fill:#0C0E11;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M713.3,540.1c-9.2-1-18.6-1.3-27.5,1.1c-8.9,2.4-17.4,7.9-21.5,16.2s-3.1,19.3,3.8,25.5 c5.5,4.9,13.7,5.9,20.9,4.4c7.2-1.5,13.8-5.2,20.3-8.8c11.2-6.3,22.3-12.6,33.5-18.9c4.1-2.3,8.2-4.7,11.4-8.1 c3.2-3.4,5.4-8.1,4.7-12.7c-0.7-4.6-4.9-8.8-9.5-8.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.6,818.1c-2.6,2.5-5.3,4.7-8,6.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M645.3,172.4c-3.3-3.9-4.4-2.4-6-7.2s-1.2-10.7,2.5-14.2c2.3-2.2,5.9-2.8,8.9-1.9c1.6,0.5,3.3-0.6,3.5-2.3 c0.5-4.3,3.2-8.4,7.1-10.2c4.7-2.2,10.8-1,14.5,2.6c1.1,1.1,2.9,1,3.9-0.1c4-4.4,10.7-6.4,16.4-4.5c4.5,1.4,8,5.1,9.7,9.4 c0.7,1.8,3,2.3,4.4,1c2.8-2.7,6.8-4.3,10.7-3.7c8.4,2.9,12.7,6.5,11.3,17c14.8-5.1,26.9,0.9,34.2,13.5c4.4,7.6,9.1,16.7,12,24.7 c3.1,8.8,2.7,22.8-1.5,31.2c-4.6,9.3-11.5,15.7-21.5,15.7c-10,0-14.5-5.5-22.2-16.7s-9.1-31.7-9-32.7c-1,8.7-2.6,9-11.9,19 c-10.6,11.4-39.1,13.3-52.8,6.1C645.9,211.8,645.4,188,645.3,172.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M757.2,202.4c0.4,2.2,0.7,4.6,0.1,6.8c-0.5,2.2-1.9,4.3-4,5.3c-3.2,1.4-6.9-0.3-9.6-2.5 c-5.7-4.6-9.1-11.6-10.6-18.7c-1.6-7.7-3.6-26.6,8.7-16.5C749.8,183.2,755.4,192.5,757.2,202.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 687.5,
    cy: 181.9,
    r: 95.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M654.8,154.1c-5.5-2-10-6.5-11.9-12c-1.9-5.5-1.3-11.8,1.7-16.8c2-3.4,5-6.1,7.7-8.9 c4.4-4.6,10.2-13.5,4.1-19.3c-2.1-2.1-5.4-2.3-8.3-2.6c-2.9-0.4-6.3-1.4-7.4-4.1c-1.3-3,0.8-6.5,3.7-8c9.5-4.7,24.6,2.3,26.4,13 c1.3,7.9-5.5,15.3-10.1,21c-2.8,3.5-5.9,7.6-5.3,12.1c0.6,5.2,5.1,8.3,7.7,12.3c1.9,2.9,1.7,5.5,2.3,8.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M708,156.1c5.5-2,10-6.5,11.9-12c1.9-5.5,1.3-11.8-1.7-16.8c-2-3.4-5-6.1-7.7-8.9c-4.4-4.6-10.2-13.5-4.1-19.3 c2.1-2.1,5.4-2.3,8.3-2.6c2.9-0.4,6.3-1.4,7.4-4.1c1.3-3-0.8-6.5-3.7-8c-9.5-4.7-24.6,2.3-26.4,13c-1.3,7.9,5.5,15.3,10.1,21 c2.8,3.5,5.9,7.6,5.3,12.1c-0.6,5.2-5.1,8.3-7.7,12.3c-1.9,2.9-1.7,5.5-2.3,8.9"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 687.5,
    cy: 181.9,
    r: 95.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057852314040503329210000004694179728811196082_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000057852314040503329210000004694179728811196082_)"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M654.8,154.1c-5.5-2-10-6.5-11.9-12c-1.9-5.5-1.3-11.8,1.7-16.8c2-3.4,5-6.1,7.7-8.9 c4.4-4.6,10.2-13.5,4.1-19.3c-2.1-2.1-5.4-2.3-8.3-2.6c-2.9-0.4-6.3-1.4-7.4-4.1c-1.3-3,0.8-6.5,3.7-8c9.5-4.7,24.6,2.3,26.4,13 c1.3,7.9-5.5,15.3-10.1,21c-2.8,3.5-5.9,7.6-5.3,12.1c0.6,5.2,5.1,8.3,7.7,12.3c1.9,2.9,1.7,5.5,2.3,8.9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M708,156.1c5.5-2,10-6.5,11.9-12c1.9-5.5,1.3-11.8-1.7-16.8c-2-3.4-5-6.1-7.7-8.9 c-4.4-4.6-10.2-13.5-4.1-19.3c2.1-2.1,5.4-2.3,8.3-2.6c2.9-0.4,6.3-1.4,7.4-4.1c1.3-3-0.8-6.5-3.7-8c-9.5-4.7-24.6,2.3-26.4,13 c-1.3,7.9,5.5,15.3,10.1,21c2.8,3.5,5.9,7.6,5.3,12.1c-0.6,5.2-5.1,8.3-7.7,12.3c-1.9,2.9-1.7,5.5-2.3,8.9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M658.8,231.6c-9-2-18.8,31.1-19,41.5c-0.2,12.2,4,22,12,22.7c8,0.7,21.5,0.5,24.7-17.7 c2-11,2.8-23.5,3.2-31.7c0.2-5.2-3.2-10-8.3-11.3L658.8,231.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M715.5,228.8c20.7,16.2,33.9,48.9,20.2,58.7c-10.4,7.5-24.3,7.5-32-2.7c-3.5-4.7-6-7-8.7-19.7 c-2.7-12.7-10.2-26.7,0.7-35.5C705.8,221.6,707.3,223.1,715.5,228.8z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M645.3,172.4c-3.3-3.9-4.4-2.4-6-7.2s-1.2-10.7,2.5-14.2c2.3-2.2,5.9-2.8,8.9-1.9c1.6,0.5,3.3-0.6,3.5-2.3 c0.5-4.3,3.2-8.4,7.1-10.2c4.7-2.2,10.8-1,14.5,2.6c1.1,1.1,2.9,1,3.9-0.1c4-4.4,10.7-6.4,16.4-4.5c4.5,1.4,8,5.1,9.7,9.4 c0.7,1.8,3,2.3,4.4,1c2.8-2.7,6.8-4.3,10.7-3.7c8.4,2.9,12.7,6.5,11.3,17c14.8-5.1,26.9,0.9,34.2,13.5c4.4,7.6,9.1,16.7,12,24.7 c3.1,8.8,2.7,22.8-1.5,31.2c-4.6,9.3-11.5,15.7-21.5,15.7c-10,0-14.5-5.5-22.2-16.7s-9.1-31.7-9-32.7c-1,8.7-2.6,9-11.9,19 c-10.6,11.4-39.1,13.3-52.8,6.1C645.9,211.8,645.4,188,645.3,172.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M691.8,229.6c0.8,5.9,2,9,3.2,13.1c1.2,4,5.1,6.5,9.2,5.9c2.9-0.4,5.4-1.2,7.5-2.1c4.2-1.8,6.1-6.6,4.4-10.8 c-1-2.4-1.4-4.5-0.4-6.7c2.5-5.9,8.4-8,11.6-15.9c2.8-6.9,1.2-17.9-5.9-19.9c-7.2-1.9-12.3,0.7-13.3,8c-0.6,4-1.9,10.3-5.3,12.5 c-2.4,1.5-6.9,4.2-9,6.1C691.7,221.6,691.4,227,691.8,229.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M669.9,246.3c3.6,0.1,4.2-2.7,5.9-6.5c0.4-0.9,1.3-3.3,1.5-4.2c0.5-2.9,0-5.2-1.5-7.7 c-1.6-2.7-2.8-2.7-5.4-4.5c-5.7-4-10.5-9.1-14.2-15c-1.2-1.9-2.3-4-4.2-5.1c-2.3-1.4-5.3-0.2-6.2,2.3c-0.7,1.9-0.7,3.8,2,7.8 c3.2,4.7,5.7,7,7.7,11.5c2,4.5,1,7.1,0.5,15.2C655.8,244.6,663.1,246.2,669.9,246.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M664.1,194.8c-1.2-0.4-2.3-1.1-3-2.1c-0.2-0.4-0.1-0.9,0.2-1.1c0.4-0.2,0.8-0.2,1.1,0.2c0.7,1,1.8,1.6,3,1.7 c1.2,0,2.4-0.5,3.1-1.5c0.3-0.3,0.8-0.4,1.1-0.2c0.3,0.3,0.4,0.8,0.2,1.1c-1,1.3-2.7,2.1-4.4,2.1 C664.9,195,664.5,194.9,664.1,194.8z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 682,
    cy: 180,
    r: 8.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 651.2,
    cy: 182.9,
    r: 8.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 647.9,
    cy: 179.9,
    r: 3.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 678.9,
    cy: 178,
    r: 3.3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M757.2,202.4c0.4,2.2,0.7,4.6,0.1,6.8c-0.5,2.2-1.9,4.3-4,5.3c-3.2,1.4-6.9-0.3-9.6-2.5 c-5.7-4.6-9.1-11.6-10.6-18.7c-1.6-7.7-3.6-26.6,8.7-16.5C749.8,183.2,755.4,192.5,757.2,202.4z"
  })))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1094,772.2c0,4.2-2,8-5.3,10.8c-3.2,2.8-7.7,4.5-12.6,4.5H853.7c-9.8,0-17.9-6.9-17.9-15.3c0-4.2,2-8,5.3-10.8 c3.2-2.8,7.7-4.5,12.6-4.5h222.4C1086,756.9,1094,763.8,1094,772.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1094,817.9c0,4.2-2,8-5.3,10.8c-3.2,2.8-7.7,4.5-12.6,4.5H853.7c-9.8,0-17.9-6.9-17.9-15.3c0-4.2,2-8,5.3-10.8 c3.2-2.8,7.7-4.5,12.6-4.5h222.4C1086,802.5,1094,809.4,1094,817.9z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1094,864.4c0,4.2-2,8-5.3,10.8c-3.2,2.8-7.7,4.5-12.6,4.5H853.7c-9.8,0-17.9-6.9-17.9-15.3c0-4.2,2-8,5.3-10.8 c3.2-2.8,7.7-4.5,12.6-4.5h222.4C1086,849,1094,855.9,1094,864.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M304.7,240L177.3,900.9c-7.8,29.8,20.9,57.7,59.2,57.7h284.2c37.6,0,66.1-26.9,59.6-56.2L466.2,238.4L304.7,240 z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M320.2,254.7l-78.8,589.6c-7.8,29.8,20.9,57.7,59.2,57.7h156c37.6,0,66.1-26.9,59.6-56.2l-59.8-591.1H320.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M477.4,211.8c0,0,0,7.6,0.4,21.8c0.1,2.2-7.6,35-92.8,35c-83.7,0-92.1-35-92.1-35l0.1-19.9 c15.2,17.8,42.1,39.6,91.6,38.5C450.1,250.7,476.3,229.2,477.4,211.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M477.5,210.4c0,17.5-26.8,41.7-92.3,42.8c0.5,0-0.6,0-0.2,0c-65.5-1.1-92.3-25.3-92.3-42.8 c0-13.3,24-18.6,40-20.5c-0.3,1,24.7,3.4,44.2,5.5c5.4,0.6,10.9,0.6,16.3,0c19.6-2.1,44.5-4.5,44.2-5.5 C453.5,191.8,477.5,197.2,477.5,210.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M385.1,222.7c-27.1,0-47-5.8-54.6-17.5c-2.8-4.3-2.2-11.4-2.2-16.4c0-18.7,22.9-49.1,56.8-49.1 c32.8,0,56.5,29.5,56.6,50.2c0,4.4,1.5,11.7-3.1,16.4C429.3,215.8,407.7,221.9,385.1,222.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 345.1,
    cy: 230.3,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 388.8,
    cy: 238,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 427,
    cy: 230.3,
    r: 7.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M324.2,451.9c-12.2-3.3-22.1-14.3-23.9-26.8c-0.8-5.5-0.1-11.3,2.8-16c3-4.7,8.4-7.9,13.9-7.3 c6.7,0.7,11.6,6.6,15,12.4c5,8.4,8.4,17.7,10,27.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M430.1,442.6c0.1-11.3,3.9-22.5,10.6-31.6c3.1-4.2,7.1-8.1,12.1-9.3c7.7-1.9,16,3.4,19,10.8 c3,7.4,1.4,16-2.6,22.9s-10.1,12.3-16.5,17s-13.1,9.1-18.8,14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M590.3,585c-1.8,15-10.2,26.5-26.4,28.2c-18.4,2-37.1-4.7-49.8-18.1c-8.5-9-14.1-20.1-18.7-31.7 c-1.6-4.1-7.3-4.3-9.3-0.4c-9.6,18.7-35.9,31.9-57.3,37.2c-26.7,6.5-55.5,4.3-80.8-6.4c-12.3-5.2-26.8-12.9-32.6-24.7 c-1.8-3.8-7.1-3.9-9.1-0.3c-11.8,21.8-24.8,27.1-45.1,30c-24.3,3.5-33-5-42.7-15.3c-10.5-11.2-9.5-29.1-3.9-43.4 c9.1-23.3,29.3-42,53.1-49.6c2.7-0.9,4.1-3.7,3.3-6.4c-3.7-11.5-2.9-21,7.2-26.8s17.2-7.2,29.5-1c2.5,1.4,5.8,0.3,7-2.3 c3.9-8.8,10.3-16.5,18.3-21.9c10.1-6.9,23.5-9.9,34.7-5.3c5.8,2.4,10.8,5.8,13.8,10.1c2.7,3.9,8.1,4.8,11.8,1.8 c1.7-1.4,3.5-2.8,5.6-4.4c7.4-5.6,17.1-8.6,26.2-6.3c9.5,2.3,16.3,9.5,21.6,18c4.7,7.5,13.9,10.7,22.2,7.9 c2.2-0.7,4.6-1.2,6.9-1.5c7.7-0.8,12.7-0.9,18,4.8c3.8,4.1,7.6,12.4,5.9,17.9c-0.8,2.7,0.6,5.6,3.4,6.4 c9.3,2.5,25.9,9.4,28.4,10.4c11.6,5.1,22.8,11.6,32.1,20.3c18.6,17.3,28.4,44.3,27,69.5C590.6,582.9,590.5,584,590.3,585z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M507.7,546.2c4.1,7.6,8.5,15.5,16.4,19.5c3.3,1.7,7.2,2.4,10.9,1.8c11.5-2.1,13.3-14.5,8.8-22.8 c-3.4-6.3-9.5-10.5-15.8-14c-7.5-4.2-16.3-8.5-25.1-10.8c-4.6-1.2-8.5,3.4-6.4,7.7C499.7,534.2,505.2,541.5,507.7,546.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.9,509.2c-6.9,0-13.8-2.4-19.2-6.8c-1.9-1.5-2.1-4.3-0.6-6.2c1.5-1.9,4.3-2.1,6.2-0.6c5,4.1,12.4,5.8,18.7,4.1 c6.4-1.7,11.9-6.5,14.2-12.6c0.9-2.3,3.4-3.4,5.7-2.6c2.3,0.9,3.4,3.4,2.6,5.7c-3.3,8.7-11,15.7-20.2,18 C360.9,508.9,358.4,509.2,355.9,509.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.9,501.2c-6.9,0-13.8-2.4-19.2-6.8c-1.9-1.5-2.1-4.3-0.6-6.2c1.5-1.9,4.3-2.1,6.2-0.6c5,4.1,12.4,5.8,18.7,4.1 c6.4-1.7,11.9-6.5,14.2-12.6c0.9-2.3,3.4-3.4,5.7-2.6c2.3,0.9,3.4,3.4,2.6,5.7c-3.3,8.7-11,15.7-20.2,18 C428.9,500.9,426.4,501.2,423.9,501.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.8,541.9c-6.9-0.5-13.6-3.4-18.6-8.1c-1.8-1.7-2-4.4-0.3-6.2c0.8-0.8,13.5-1.7,23.6-3.6c11.6-2.2,22.7-7.5,23.9-6.9 c2.2,1,1.3,5.8,0.3,8c-3.9,8.5-12.1,14.8-21.4,16.5C397.8,541.9,395.3,542,392.8,541.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M242.1,536.4c-3.6,4-7,8.5-8.4,13.7c-1.4,5.2-0.3,11.4,3.7,15c4.8,4.2,12.5,3.6,17.9,0.2 c5.4-3.4,9.1-9,12.3-14.5c3.4-5.8,6.5-11.8,8-18.3c0.5-2.2,0.5-6-0.2-10.2c-0.9-5.3-7-7.8-11.3-4.8 C256.1,523.2,247.2,530.8,242.1,536.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M484.8,679.4c-1.4,4.9-4,9.3-7.9,12.9c-14,12.7-35.5,13.3-51,24.2c-16.5,11.6-23.3,32.8-37.3,47.3 c-20.5,21.3-54.1,14.6-78.1-2.6c-12.3-8.8-21.3-19.3-26.7-31.3c-5.2-11.5-7.2-24.5-5.8-38.9c1.6-16.6,19.7-43,37.7-49.7 c18-6.7,54,3.5,70.2-5.1c17.6-9.3,26.9-20.5,49.7-22.3c18.4-1.4,33.5,11.5,42.8,27.4C484.8,652.7,488.3,667.4,484.8,679.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M484.8,679.4c-3.5,32-23.6,41.4-44.2,45.8c-16.2,3.5-29.9,19.4-42.8,44.5c-19.8,38.5-103.6,19.8-114.1-39.9 c5.5,12.1,14.4,22.6,26.7,31.3c24.1,17.2,57.6,23.9,78.1,2.6c14-14.5,20.8-35.7,37.3-47.3c15.5-10.9,37-11.5,51-24.2 C480.8,688.8,483.4,684.3,484.8,679.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M485.1,661.9c0.4,6.5,0.2,12.3-0.3,17.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 644.4,
    y1: 596.8,
    x2: 639.2,
    y2: 599.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 579.9,
    y1: 619,
    x2: 577.6,
    y2: 619.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M334.8,676.3l5.2-1.6c4.6-1.4,9.6,0.9,11.4,5.3l11.8,27.9c2.1,4.9-0.3,10.4-5.2,12.4l-4,1.6 c-4.7,1.9-10-0.2-12.1-4.8L329,689.2C326.6,684.1,329.3,677.9,334.8,676.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M417.4,678.5l-6.3-15.9c-2.4-6.1,0.6-13.1,6.7-15.6l164-64.9c6.1-2.4,13.1,0.6,15.6,6.7l6.3,15.9 c2.4,6.1-0.6,13.1-6.7,15.6l-164,64.9C426.8,687.6,419.8,684.6,417.4,678.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M656.4,596.8l-6.9,13.7l-32.5,12h-29.1l-14-27.8c-2.3-7-0.5-14.6,4.6-20.2l0.9-1c2.5-2.7,5.6-4.8,9.2-6 l24.5-8.9c11.2-4.1,23.8,0.5,29.2,10.4L656.4,596.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M656.4,596.7v1.5c0,9.1-6.2,17.3-15.5,20.3l-27.2,8.9c-4.4,1.4-9.2,1.6-13.8,0.5l-12-3.5v-3.4 C619.1,620.3,640.3,610.7,656.4,596.7z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9299 -0.3678 0.3678 0.9299 -219.3969 196.7056)",
    className: "st9",
    cx: 406.3,
    cy: 673.9,
    rx: 18.8,
    ry: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M612.6,575.6L343.4,688.5c-0.7,0.3-1.4,0-1.7-0.7l-0.7-1.7c-0.3-0.7,0-1.4,0.7-1.7l269.2-112.9 c0.7-0.3,1.4,0,1.7,0.7l0.7,1.7C613.5,574.6,613.2,575.4,612.6,575.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M616.3,584.5L347.1,697.3c-0.7,0.3-1.4,0-1.7-0.7l-0.7-1.7c-0.3-0.7,0-1.4,0.7-1.7l269.2-112.9 c0.7-0.3,1.4,0,1.7,0.7l0.7,1.7C617.3,583.4,616.9,584.2,616.3,584.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M620,593.3L350.8,706.2c-0.7,0.3-1.4,0-1.7-0.7l-0.7-1.7c-0.3-0.7,0-1.4,0.7-1.7l269.2-112.9 c0.7-0.3,1.4,0,1.7,0.7l0.7,1.7C621,592.3,620.6,593,620,593.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M623.7,602.2L354.5,715c-0.7,0.3-1.4,0-1.7-0.7l-0.7-1.7c-0.3-0.7,0-1.4,0.7-1.7L622,598.1 c0.7-0.3,1.4,0,1.7,0.7l0.7,1.7C624.7,601.1,624.4,601.9,623.7,602.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M587.9,626c-2,0-3.8-1.1-4.7-3.1l-13.7-30.8c-1.2-2.6,0-5.6,2.6-6.8c2.6-1.1,5.6,0,6.8,2.6l13.7,30.8 c1.2,2.6,0,5.6-2.6,6.8C589.3,625.8,588.6,626,587.9,626z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 575.9,
    cy: 562.6,
    r: 6.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 610.1,
    cy: 550.6,
    r: 6.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 654.6,
    cy: 622.5,
    r: 6.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 622.1,
    cy: 634.5,
    r: 6.9
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M211.8,658.8c22-2.2,27-3,51.3-11.6c12-4.2,26.1-7.3,32-18.6c3.9-7.4,6.8-16.6,4.4-24.6 c-2-6.5-2.8-16.1,4.9-19.4c5.5-2.3,10.9,2.5,12.1,6.5c2,6.4,7.6,11.3,12,4.4c3.7-5.9,9.8-23.5,13.8-26.4c7.8-5.6,20.8-5.1,25.1,3.5 c4.4,8.8-2.4,18.6-5.4,27.9c4-5.9,9.1-11,15.1-15c8.6-5.7,20.1,1.1,19.2,11.4c-0.6,7.6-5.3,11.3-8.4,18.3c4.6-3.3,9.4-6.7,14.9-8.1 c5.5-1.3,12.4-0.3,15.4,4.4c6.8,10.6-5.8,21.7-19,31.6c-13.2,9.9-13.8,16.4-18.9,23.8c-8.7,12.6-16.7,21.2-39.4,26.6 c-33.3,8-77.4,8-126.5,8.5c-16.1,0.2-19.3-13-19.3-25.7S204.2,659.6,211.8,658.8z"
  }))), /*#__PURE__*/React.createElement("g", null, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 767.1,
    cy: 808.1,
    r: 99.3
  })), /*#__PURE__*/React.createElement("g", null, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M717.2,766.6c-5.6-1.5-10.1-6.5-10.9-12.3c-0.4-2.5-0.1-5.2,1.3-7.3c1.4-2.1,3.9-3.6,6.4-3.3 c3.1,0.3,5.3,3,6.9,5.7c2.3,3.9,3.8,8.1,4.6,12.5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M772.9,761.6c0.1-4.9,1.7-9.8,4.6-13.8c1.4-1.8,3.1-3.5,5.3-4.1c3.4-0.8,7,1.5,8.3,4.7c1.3,3.2,0.6,7-1.1,10 s-4.4,5.4-7.2,7.5c-2.8,2.1-5.7,4-8.2,6.4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M709.7,788.9c-3.2-4.6-4.6-3.1-5.8-8.5s-0.2-11.9,4.3-15.4c2.8-2.2,6.8-2.5,9.9-1.1c1.7,0.7,3.7-0.3,4.1-2.1 c1-4.7,4.4-8.9,8.9-10.5c5.4-2,11.9,0,15.7,4.3c1.1,1.3,3,1.4,4.3,0.2c4.9-4.4,12.4-5.9,18.5-3.3c4.8,2,8.3,6.4,9.7,11.4 c0.6,2.1,3.1,2.9,4.8,1.5c3.4-2.7,7.9-4,12.1-2.9c8.9,4.1,13.3,8.4,10.6,19.9c31.2-7.5,97.4,7.5,89.3,35.1 c-6.3,16.8-36.5,31.4-76.2,15.3c-4.7-1.9-16.1-6.8-24.3-17.5c-2,9.4-5.1,15.3-16.3,25.3c-12.8,11.4-44.3,10.6-58.7,1.2 C706.3,832.3,708.1,805.9,709.7,788.9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M833.1,813.2c4.6,2.1,9.8,4,15.8,4.8c6,0.8,13.1,0.2,17.3-2.1c4.9-2.7,4.2-7.1,0.3-10.2 c-3.9-3.1-10.4-5.2-16.7-7c-6.7-1.9-13.6-3.7-21.2-4.6c-2.5-0.3-7-0.3-11.8,0.1c-6.1,0.5-9.1,4-5.5,6.5 C817.8,805.2,826.6,810.3,833.1,813.2z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 749.2,
    cy: 801,
    r: 9.2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 715.1,
    cy: 801,
    r: 9.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M732.1,826.6c-3.2,0-5.7-2.4-5.7-5.4c0-3.1,2.5-5.4,5.7-5.4s5.7,2.4,5.7,5.4C737.8,824.2,735.3,826.6,732.1,826.6z  M732.1,819c-1.9,0-3.2,1.2-3.2,2.1c0,0.9,1.2,2.1,3.2,2.1s3.2-1.2,3.2-2.1C735.2,820.3,734,819,732.1,819z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000067207497814257217530000013926025670409765037_",
    cx: 767.1,
    cy: 808.1,
    r: 99.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061443892949825305580000014552739971111085469_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067207497814257217530000013926025670409765037_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000061443892949825305580000014552739971111085469_)",
      fill: "#B2ECDA"
    },
    d: "M714.3,894.2 c1.6-18.2,15.5-34.4,32.9-40.1c17.4-5.7,37.3-1.5,52,9.5c13.3,9.9,25.5,35.6,27.4,46.1l-77.5,4.8L714.3,894.2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M695.3,867.5c-10,0-20.7,21.2-10.7,33.5c2.6,3.8,6.4,6.7,10.7,8.3c18,5.7,32.4-11.8,30.7-22.8 c-1.7-10.9-3.7-10.2-11-15.6C707.7,865.5,700.9,867.2,695.3,867.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M806.1,884.3c-5.2,2.9-7.3,9.3-4.9,14.8c1.5,3.4,3.4,6.6,5.8,9.5c4.3,5.1,10.4,8.9,17.1,9.2 c8.3,0.4,16.5-5.2,19.2-13s-0.3-17.3-7.1-22.1c0,0-1.7-4.7-16.8-2.6C813.8,880.8,809.4,882.5,806.1,884.3z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st18",
    cx: 761.4,
    cy: 814,
    rx: 4.1,
    ry: 4.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st18",
    cx: 711.2,
    cy: 816.5,
    rx: 4.1,
    ry: 4.2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 711.9,
    cy: 798.4,
    r: 3.7
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 746,
    cy: 798.4,
    r: 3.7
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1090.5,917.5l0.9-10.2h-24.6c-2.9,0-5.2,2.3-5.2,5.2c0,1.4,0.6,2.7,1.5,3.7c0.9,0.9,2.2,1.5,3.7,1.5h4 c3.1,0,5.5,2.5,5.5,5.5c0,1.5-0.6,2.9-1.6,3.9c-1,1-2.4,1.6-3.9,1.6h-18.6c-3,0-5.5,2.5-5.5,5.5c0,1.5,0.6,2.9,1.6,3.9 c1,1,2.4,1.6,3.9,1.6h24.1c-7.1,5.7-16.1,9.1-25.8,9.1c-2.7,0-5.4-0.3-7.9-0.8c-8.9-1.7-16.9-6.4-22.7-12.9 c-3.1-3.4-5.6-7.4-7.4-11.7h22.8c1.6,0,3-0.6,4-1.7c1-1,1.7-2.5,1.7-4c0-3.2-2.6-5.7-5.7-5.7h-25.8c-0.2-1.5-0.2-2.9-0.2-4.4 c0-22.7,18.4-41.2,41.2-41.2c22.7,0,41.2,18.4,41.2,41.2C1091.7,911,1091.3,914.3,1090.5,917.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 1040.9,
    cy: 885.6,
    r: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1091.7,907.3c0,0,0,6.5-1.2,10.2c-1,6,0,0,0,0c-2.2,8.9-7.2,16.6-14.1,22.2h-24.1c-1.5,0-2.9-0.6-3.9-1.6 c-1-1-1.6-2.4-1.6-3.9c0-3,2.5-5.5,5.5-5.5h18.6c1.5,0,2.9-0.6,3.9-1.6c1-1,1.6-2.4,1.6-3.9c0-3.1-2.5-5.5-5.5-5.5h-4 c-1.4,0-2.7-0.6-3.7-1.5c-0.9-0.9-1.5-2.2-1.5-3.7c0-2.9,2.3-5.2,5.2-5.2L1091.7,907.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1041.1,917.8c0,1.6-0.6,3-1.7,4c-1,1-2.5,1.7-4,1.7h-22.8c-1.5-3.6-2.5-7.4-2.9-11.4h25.8 C1038.5,912,1041.1,914.6,1041.1,917.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1072.3,900.1h-15.1c-1.7,0-3.2-1.4-3.2-3.2v-0.5c0-1.7,1.4-3.2,3.2-3.2h15.1c1.7,0,3.2,1.4,3.2,3.2v0.5 C1075.5,898.7,1074.1,900.1,1072.3,900.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M862.1,747.8l-20.5-9l-15.7-6.9c-1.4-0.6-2.7,0.9-1.9,2.2l10.4,16.1c0.9,1.7-1,3.5-2.6,2.5 c-15.8-8.7-31.5-17.7-47.1-26.9c-8-4.7-14.5-8.8-22.4-13.8c-8.5-5.5-16.7-11.3-16.7-11.3c-3.6-3.6-28.1-56.2-28.1-56.2l17.4,3.1 c0,0,37.6-3.6,47.2-2.4c15.5,12.5,45.4,37.9,54.6,46.2c8.1,7.2,15.9,14.7,24,21.9c1,0.9,0.2,2.5-1.1,2.3l-18.5-3.5 c-1.4-0.3-2.4,1.4-1.4,2.5l5.1,5.7l20.7,23.2C867.1,745.6,864.8,748.8,862.1,747.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M862.7,748.4c0,0-20.5-9-20.5-9c-13.5-6.6-27.1-13.2-40.6-19.7c-8.8-4.3-17.6-8.6-26.4-12.9 c-9.6-4.7-19.9-8-25.3-18c-5.4-10-41.9-36.8-32.4-44.2c6.1-4.8,50.6,7.4,57.9,9c6.8,1.5,12.5,5.6,17.4,10.4 c4.9,4.9,8.9,10.5,13.7,15.4c5.3,5.5,10.5,11.2,15.8,16.8c7.7,8.2,15.4,16.4,23.1,24.6l20.7,23.2 C867.7,746.2,865.4,749.4,862.7,748.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M782.7,650.4l-9.5,15.4c-1,1.7-3.1,2.3-4.9,1.5l-28.1-12.6l-22.9-10.2l19.5,16l23.7,19.4 c1.5,1.3,1.9,3.5,0.8,5.1l-9.5,15.3c-1.5,2.4-4.9,2.5-6.5,0.2L734,684.4l-31.4-44.8c-2-2.8,0.4-6.6,3.8-6.1l54,8.1l19.6,2.9 C782.7,644.9,784.2,648,782.7,650.4z"
  }))), /*#__PURE__*/React.createElement("g", null, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M786.9,587.2H937c23.3,0,42.1-18.9,42.1-42.1V395.1c0-23.3-18.9-42.1-42.1-42.1H786.9 c-23.3,0-42.1,18.9-42.1,42.1v150.1C744.8,568.4,763.6,587.2,786.9,587.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000178173411698008464770000013889631832003685302_",
    d: "M786.3,587.4h150.4c23.2,0,41.9-18.8,41.9-41.9V395.1 c0-23.2-18.8-41.9-41.9-41.9H786.3c-23.2,0-41.9,18.8-41.9,41.9v150.4C744.4,568.6,763.2,587.4,786.3,587.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137845063940924438150000002597333682834609838_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178173411698008464770000013889631832003685302_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000137845063940924438150000002597333682834609838_)",
      fill: "#7FE0C1"
    },
    d: "M974.7,608.9 c-1.7-19.9-40.5-63.3-59.4-69.5c-18.9-6.2-40.6-1.6-56.6,10.3c-14.5,10.8-41,56.2-43,67.7h72l49.9-1.4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M821.7,571.4c-1.8-2.9-4.3-5.5-7.1-7.3c-5-3.3-10.9-4.3-15.9-7.5c-7.6-5-15.2-18.2-11.4-27.4 c1.4-3.5,2.4-8.7-1.7-10.9c-2.9-1.6-6.4,0.8-7.2,3c-2.2,6.9-7,7.4-9.1,3.4c-1.8-3.4-4-12.8-6.1-14.6c-4-3.5-8.9-6.1-11.7-1.6 c-1.8,3,1,9.1,3.5,14.5c0.5,1-0.9,1.8-1.5,1c-2.8-3.6-6.2-7.4-7.9-8.8c-4.5-3.6-11.1-0.4-11.1,5.3c0,2.7,3.4,7.3,6.3,11.3 c0.6,0.9-0.6,1.9-1.4,1.2c-3.3-3.1-7.2-6.5-9-7.1c-3-1-6.8-0.8-8.7,1.7c-3.8,4.8,4.6,11.5,7,15.2c4.1,6.1,7.4,12.8,11.7,18.8 c3.8,5.4,8.7,10.3,14.7,13.2c6.3,3,12.2,4,17.7,8.9c9.1,8.2,16.8,12.9,29.2,14.2c8.8,0.9,17.7-2.7,20.8-8 C826.2,583.5,825.1,576.8,821.7,571.4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M897.7,429C897.7,429,897.7,429,897.7,429C897.7,429,897.7,429,897.7,429C897.7,429,897.7,429,897.7,429z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M856.7,433.6c2.9-5.3,3.2-11.8,1-17.3c-2.2-5.5-7-10-12.7-11.8c-3.9-1.2-8-1.3-12-1.6 c-6.5-0.6-17-3.5-16.3-12.1c0.3-3,2.6-5.4,4.6-7.7c2-2.3,3.9-5.3,3-8.2c-1-3.2-5-4.5-8.2-3.6c-10.5,2.8-17.3,18.5-11.5,27.9 c4.4,7,14.6,8,22,9.3c4.6,0.8,9.6,1.9,12.3,5.7c3,4.4,1.7,9.8,2.4,14.7c0.5,3.5,2.4,5.4,4.2,8.4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M894.8,439c6-0.2,11.8-3.3,15.4-8c3.6-4.8,5-11.2,3.6-17c-0.9-3.9-3-7.5-4.7-11.1c-2.8-5.8-5.7-16.4,2.1-20.2 c2.7-1.3,6-0.5,8.9,0s6.5,0.6,8.5-1.7c2.2-2.5,1.3-6.6-1.1-8.9c-7.8-7.6-24.7-5.4-29.8,4.4c-3.8,7.3,0.6,16.7,3.3,23.7 c1.7,4.3,3.3,9.2,1.4,13.5c-2.2,4.9-7.6,6.5-11.4,9.6c-2.7,2.3-3.4,4.9-5,7.9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M830.4,496.1c4.5,14.9,13.6,27,27.9,33.2c14.2,6.2,40.9-1.2,52.9-11c10.4-8.5,12.9-25.3,9.2-38.8 c-0.5-1.7,1.5-2.9,2.8-1.8c17.6,14.6,40.5,29.7,62.1,33.6c18.7,3.4,40.6,1.7,53-12.7c8.8-10.1,10.9-25.3,6.2-37.8 c-4.7-12.6-15.7-22.3-28.3-26.7c-29.4-10-61.8,8.1-92.4,2.7c-0.5-0.1-1-0.2-1.5-0.3c-9.5-3.5-8.9-9.7-12.9-12.2 c-4.1-2.6-10.4-0.1-11.7,4.6c0,0,0,0,0,0c0,0,0,0,0,0c-0.6-4.4-4.3-8.2-8.7-8.9c-4-0.6-10.8,5.5-10.9,5.9 c-3.9-7.5-11.1-6.6-14.9-5.5c-3.6,1.1-7,4-5.5,11.6c-0.5-4.7-5.3-7.2-11.5-5.7c-4,1-10,6-9,11s0,6,5,7c-10,1-12.6,11.8-14,17 C825.4,472.2,827.2,485.4,830.4,496.1z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M819.3,460c-3.6,0.3-6.4,3.3-6.4,6.9c0,6.5,2.1,15.3,14.1,14.5c18.7-1.3,31.3-13.2,31.3-13.2s6.9,11.7,25.4,9.1 c10.2-1.4,15.2-8.4,17.6-14.4c1.7-4.2-1.6-8.7-6.1-8.4L819.3,460z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M892.4,470.1c0.2,0,0.5-0.1,0.7-0.2c0.6-0.4,0.7-1.1,0.3-1.7l-7.3-10.7c-0.4-0.6-1.1-0.7-1.7-0.3 c-0.6,0.4-0.7,1.1-0.3,1.7l7.3,10.7C891.6,469.9,892,470.1,892.4,470.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M882.4,471.4c0.2,0,0.5-0.1,0.7-0.2c0.6-0.4,0.7-1.1,0.3-1.7l-7.3-10.7c-0.4-0.6-1.1-0.7-1.7-0.3 c-0.6,0.4-0.7,1.1-0.3,1.7l7.3,10.7C881.7,471.2,882,471.4,882.4,471.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M873,472.7c0.2,0,0.5-0.1,0.7-0.2c0.6-0.4,0.7-1.1,0.3-1.7l-7.3-10.7c-0.4-0.6-1.1-0.7-1.7-0.3 c-0.6,0.4-0.7,1.1-0.3,1.7l7.3,10.7C872.2,472.5,872.6,472.7,873,472.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M845.1,474.1c0.2,0,0.5-0.1,0.7-0.2c0.6-0.4,0.7-1.1,0.3-1.7l-7.3-10.7c-0.4-0.6-1.1-0.7-1.7-0.3 c-0.6,0.4-0.7,1.1-0.3,1.7l7.3,10.7C844.3,473.9,844.7,474.1,845.1,474.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M835.2,475.4c0.2,0,0.5-0.1,0.7-0.2c0.6-0.4,0.7-1.1,0.3-1.7l-7.3-10.7c-0.4-0.6-1.1-0.7-1.7-0.3 c-0.6,0.4-0.7,1.1-0.3,1.7l7.3,10.7C834.4,475.2,834.8,475.4,835.2,475.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M825.7,476.7c0.2,0,0.5-0.1,0.7-0.2c0.6-0.4,0.7-1.1,0.3-1.7l-7.3-10.7c-0.4-0.6-1.1-0.7-1.7-0.3 c-0.6,0.4-0.7,1.1-0.3,1.7l7.3,10.7C825,476.5,825.3,476.7,825.7,476.7z"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M950.9,456c7.1-0.6,14.5-1.2,20.9,2.4c2.7,1.5,5,3.9,6.2,6.7c3.8,8.9-4,15.8-11.8,16.4 c-5.9,0.5-11.6-1.8-16.9-4.5c-6.3-3.3-13.3-7.4-18.9-12.4c-2.9-2.6-1.5-7.4,2.4-7.9C939,455.9,946.5,456.4,950.9,456z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M850.4,493.9c14.3-0.2,28.5-3.4,41.5-9.5c1.3-0.6,1.9-2.2,1.3-3.6c-0.6-1.3-2.2-1.9-3.6-1.3c-14.7,6.9-30.9,9.9-47.1,8.8 c-1.5-0.1-2.8,1-2.9,2.5c-0.1,1.5,1,2.8,2.5,2.9C844.9,493.9,847.7,494,850.4,493.9z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st18",
    cx: 899.2,
    cy: 477,
    rx: 4.7,
    ry: 4.8
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st18",
    cx: 829.3,
    cy: 486,
    rx: 4.7,
    ry: 4.8
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M779.4,457.7l2.2,10.5c1.1,5-5.3,8.1-8.6,4.2l-12.5-14.7h-46.1c-13.5,0-24.5-11-24.5-24.5v-15.4 c0-13.5,11-24.5,24.5-24.5h64.5c13.5,0,24.5,11,24.5,24.5v15.3c0,13-10.2,23.8-23.2,24.5L779.4,457.7z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M309.8,863.3l-21.9,13.2c-2.5,1.5-5.6-0.3-5.7-3.1l-0.5-25.5c-0.1-2.9,3-4.7,5.6-3.3l22.3,12.4 C312.2,858.2,312.3,861.8,309.8,863.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M475.5,860.4c0,3.3-1.6,6.3-4.1,8.5c-2.5,2.2-6.1,3.5-9.9,3.5h-81.9c-7.7,0-14.1-5.4-14.1-12.1 c0-3.3,1.6-6.3,4.1-8.5c2.5-2.2,6.1-3.5,9.9-3.5h81.9C469.1,848.4,475.5,853.8,475.5,860.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 339.7,
    cy: 860.5,
    r: 11.5
  })))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M776.2,145.2c-3.3,3.9-6.6,7.9-10,11.8c-4.3-2.8-8.5-5.8-12.7-8.7c-5.7-3.8-12.8-10.1-11.4-17.8 c0.5-2.6,2.1-5,4.4-6.5c2.3-1.4,5.1-1.9,7.7-1.2c3.5,0.9,6.3,3.7,8.4,6.7c1.2-3.5,3.2-6.9,6.3-8.7c2.3-1.4,5.2-1.7,7.8-0.9 c2.6,0.8,4.8,2.7,5.9,5.1C785.9,132.1,780.7,140,776.2,145.2z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M740.8,105.5c-1.7,2-3.3,4.1-5.1,6c-2.2-1.4-4.3-3-6.5-4.4c-2.9-1.9-6.5-5.1-5.8-9.1c0.2-1.3,1.1-2.6,2.2-3.3 c1.2-0.7,2.6-1,3.9-0.6c1.8,0.5,3.2,1.9,4.3,3.4c0.6-1.8,1.6-3.5,3.2-4.4c1.2-0.7,2.6-0.9,4-0.5c1.3,0.4,2.4,1.4,3,2.6 C745.7,98.8,743.1,102.8,740.8,105.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroIllustration);
export default __webpack_public_path__ + "static/media/Hero_Illustration.d1a25b66e54e4b0bd1ad46424e50ef30.svg";
export { ForwardRef as ReactComponent };